
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';
import { IImage } from '@/common/interface';
import ShopService from '@/services/shop.service';
import lazyInject from '@/di';


@Component({
  components: {
    Viewer,
  },
})
export default class ShopLicenseField extends Vue {
  val: IImage[] = [];

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  value!: IImage[];

  @Prop()
  label!: string;

  @Prop()
  shopLicenseInfo!: any;


  businessLicenseInfo: any = {};

  @Watch('value')
  async watchValue() {
    if (this.value && this.value.length) {
      this.val = [...this.value];
      if (this.label === 'shoplicense' || this.label === 'shopLicense') {
        // if (this.shopLicenseInfo) {
        console.log(this.shopLicenseInfo, this.label);

        this.businessLicenseInfo = this.shopLicenseInfo;
        // }
      }
    } else {
      this.val = [];
    }
  }

  mounted() {
    this.watchValue();
  }
}
